// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const Fullcode = styled<any, Theme>('span')`
  white-space: nowrap;
`;

export default Fullcode;
